/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { NicePayCallbackRequest } from '../models';
// @ts-ignore
import type { NicePayCallbackResponse } from '../models';
// @ts-ignore
import type { NicePayConfigResponse } from '../models';
/**
 * NicepayApi - axios parameter creator
 * @export
 */
export const NicepayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * NicePay 결제에 필요한 설정 정보를 조회합니다
         * @summary NicePay 설정 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNicePayConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment-methods/nicepay/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * NicePay에서 빌링키 등록 결과를 받는 콜백입니다
         * @summary NicePay 빌링 콜백
         * @param {NicePayCallbackRequest} nicePayCallbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nicePayBillingCallback: async (nicePayCallbackRequest: NicePayCallbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nicePayCallbackRequest' is not null or undefined
            assertParamExists('nicePayBillingCallback', 'nicePayCallbackRequest', nicePayCallbackRequest)
            const localVarPath = `/api/v1/payment-methods/nicepay/billing/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nicePayCallbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * NicePay에서 결제 결과를 받는 콜백입니다
         * @summary NicePay 결제 콜백
         * @param {NicePayCallbackRequest} nicePayCallbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nicePayPaymentCallback: async (nicePayCallbackRequest: NicePayCallbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nicePayCallbackRequest' is not null or undefined
            assertParamExists('nicePayPaymentCallback', 'nicePayCallbackRequest', nicePayCallbackRequest)
            const localVarPath = `/api/v1/payment-methods/nicepay/payment/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nicePayCallbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * NicePay 결제 완료 후 리턴되는 페이지입니다
         * @summary NicePay 리턴 페이지
         * @param {string} [authResultCode] 
         * @param {string} [authResultMsg] 
         * @param {string} [tid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nicePayReturn: async (authResultCode?: string, authResultMsg?: string, tid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment-methods/nicepay/return`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authResultCode !== undefined) {
                localVarQueryParameter['authResultCode'] = authResultCode;
            }

            if (authResultMsg !== undefined) {
                localVarQueryParameter['authResultMsg'] = authResultMsg;
            }

            if (tid !== undefined) {
                localVarQueryParameter['tid'] = tid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NicepayApi - functional programming interface
 * @export
 */
export const NicepayApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NicepayApiAxiosParamCreator(configuration)
    return {
        /**
         * NicePay 결제에 필요한 설정 정보를 조회합니다
         * @summary NicePay 설정 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNicePayConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NicePayConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNicePayConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NicepayApi.getNicePayConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * NicePay에서 빌링키 등록 결과를 받는 콜백입니다
         * @summary NicePay 빌링 콜백
         * @param {NicePayCallbackRequest} nicePayCallbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nicePayBillingCallback(nicePayCallbackRequest: NicePayCallbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NicePayCallbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nicePayBillingCallback(nicePayCallbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NicepayApi.nicePayBillingCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * NicePay에서 결제 결과를 받는 콜백입니다
         * @summary NicePay 결제 콜백
         * @param {NicePayCallbackRequest} nicePayCallbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nicePayPaymentCallback(nicePayCallbackRequest: NicePayCallbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NicePayCallbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nicePayPaymentCallback(nicePayCallbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NicepayApi.nicePayPaymentCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * NicePay 결제 완료 후 리턴되는 페이지입니다
         * @summary NicePay 리턴 페이지
         * @param {string} [authResultCode] 
         * @param {string} [authResultMsg] 
         * @param {string} [tid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nicePayReturn(authResultCode?: string, authResultMsg?: string, tid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nicePayReturn(authResultCode, authResultMsg, tid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NicepayApi.nicePayReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NicepayApi - factory interface
 * @export
 */
export const NicepayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NicepayApiFp(configuration)
    return {
        /**
         * NicePay 결제에 필요한 설정 정보를 조회합니다
         * @summary NicePay 설정 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNicePayConfig(options?: RawAxiosRequestConfig): AxiosPromise<NicePayConfigResponse> {
            return localVarFp.getNicePayConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * NicePay에서 빌링키 등록 결과를 받는 콜백입니다
         * @summary NicePay 빌링 콜백
         * @param {NicepayApiNicePayBillingCallbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nicePayBillingCallback(requestParameters: NicepayApiNicePayBillingCallbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<NicePayCallbackResponse> {
            return localVarFp.nicePayBillingCallback(requestParameters.nicePayCallbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * NicePay에서 결제 결과를 받는 콜백입니다
         * @summary NicePay 결제 콜백
         * @param {NicepayApiNicePayPaymentCallbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nicePayPaymentCallback(requestParameters: NicepayApiNicePayPaymentCallbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<NicePayCallbackResponse> {
            return localVarFp.nicePayPaymentCallback(requestParameters.nicePayCallbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * NicePay 결제 완료 후 리턴되는 페이지입니다
         * @summary NicePay 리턴 페이지
         * @param {NicepayApiNicePayReturnRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nicePayReturn(requestParameters: NicepayApiNicePayReturnRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponse> {
            return localVarFp.nicePayReturn(requestParameters.authResultCode, requestParameters.authResultMsg, requestParameters.tid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NicepayApi - interface
 * @export
 * @interface NicepayApi
 */
export interface NicepayApiInterface {
    /**
     * NicePay 결제에 필요한 설정 정보를 조회합니다
     * @summary NicePay 설정 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NicepayApiInterface
     */
    getNicePayConfig(options?: RawAxiosRequestConfig): AxiosPromise<NicePayConfigResponse>;

    /**
     * NicePay에서 빌링키 등록 결과를 받는 콜백입니다
     * @summary NicePay 빌링 콜백
     * @param {NicepayApiNicePayBillingCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NicepayApiInterface
     */
    nicePayBillingCallback(requestParameters: NicepayApiNicePayBillingCallbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<NicePayCallbackResponse>;

    /**
     * NicePay에서 결제 결과를 받는 콜백입니다
     * @summary NicePay 결제 콜백
     * @param {NicepayApiNicePayPaymentCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NicepayApiInterface
     */
    nicePayPaymentCallback(requestParameters: NicepayApiNicePayPaymentCallbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<NicePayCallbackResponse>;

    /**
     * NicePay 결제 완료 후 리턴되는 페이지입니다
     * @summary NicePay 리턴 페이지
     * @param {NicepayApiNicePayReturnRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NicepayApiInterface
     */
    nicePayReturn(requestParameters?: NicepayApiNicePayReturnRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponse>;

}

/**
 * Request parameters for nicePayBillingCallback operation in NicepayApi.
 * @export
 * @interface NicepayApiNicePayBillingCallbackRequest
 */
export interface NicepayApiNicePayBillingCallbackRequest {
    /**
     * 
     * @type {NicePayCallbackRequest}
     * @memberof NicepayApiNicePayBillingCallback
     */
    readonly nicePayCallbackRequest: NicePayCallbackRequest
}

/**
 * Request parameters for nicePayPaymentCallback operation in NicepayApi.
 * @export
 * @interface NicepayApiNicePayPaymentCallbackRequest
 */
export interface NicepayApiNicePayPaymentCallbackRequest {
    /**
     * 
     * @type {NicePayCallbackRequest}
     * @memberof NicepayApiNicePayPaymentCallback
     */
    readonly nicePayCallbackRequest: NicePayCallbackRequest
}

/**
 * Request parameters for nicePayReturn operation in NicepayApi.
 * @export
 * @interface NicepayApiNicePayReturnRequest
 */
export interface NicepayApiNicePayReturnRequest {
    /**
     * 
     * @type {string}
     * @memberof NicepayApiNicePayReturn
     */
    readonly authResultCode?: string

    /**
     * 
     * @type {string}
     * @memberof NicepayApiNicePayReturn
     */
    readonly authResultMsg?: string

    /**
     * 
     * @type {string}
     * @memberof NicepayApiNicePayReturn
     */
    readonly tid?: string
}

/**
 * NicepayApi - object-oriented interface
 * @export
 * @class NicepayApi
 * @extends {BaseAPI}
 */
export class NicepayApi extends BaseAPI implements NicepayApiInterface {
    /**
     * NicePay 결제에 필요한 설정 정보를 조회합니다
     * @summary NicePay 설정 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NicepayApi
     */
    public getNicePayConfig(options?: RawAxiosRequestConfig) {
        return NicepayApiFp(this.configuration).getNicePayConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * NicePay에서 빌링키 등록 결과를 받는 콜백입니다
     * @summary NicePay 빌링 콜백
     * @param {NicepayApiNicePayBillingCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NicepayApi
     */
    public nicePayBillingCallback(requestParameters: NicepayApiNicePayBillingCallbackRequest, options?: RawAxiosRequestConfig) {
        return NicepayApiFp(this.configuration).nicePayBillingCallback(requestParameters.nicePayCallbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * NicePay에서 결제 결과를 받는 콜백입니다
     * @summary NicePay 결제 콜백
     * @param {NicepayApiNicePayPaymentCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NicepayApi
     */
    public nicePayPaymentCallback(requestParameters: NicepayApiNicePayPaymentCallbackRequest, options?: RawAxiosRequestConfig) {
        return NicepayApiFp(this.configuration).nicePayPaymentCallback(requestParameters.nicePayCallbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * NicePay 결제 완료 후 리턴되는 페이지입니다
     * @summary NicePay 리턴 페이지
     * @param {NicepayApiNicePayReturnRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NicepayApi
     */
    public nicePayReturn(requestParameters: NicepayApiNicePayReturnRequest = {}, options?: RawAxiosRequestConfig) {
        return NicepayApiFp(this.configuration).nicePayReturn(requestParameters.authResultCode, requestParameters.authResultMsg, requestParameters.tid, options).then((request) => request(this.axios, this.basePath));
    }
}

